import React from 'react'

import EtcPage from 'Components/EtcPage/EtcPage'

export default function Student() {
  return <EtcPage content="학생 페이지입니다." />
}
